export const classicButtons = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#605F68"
                        d="M21.817 7.894c.057-1.01-.652-1.937-1.65-2.102-4.152-.683-3.833-3.872-8.297-3.872S7.725 5.109 3.574 5.792c-.999.164-1.708 1.091-1.65 2.102.427 7.63 3.48 11.255 9.946 14.026 6.466-2.771 9.52-6.396 9.947-14.026z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="M10.87 15.92a.997.997 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414l2.293 2.293 4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a.997.997 0 0 1-.707.293z"
                    />
                </g>
            </svg>
        ),
        link: '/',
        classname: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#605F68"
                        d="M18.806 4.846C15.18 1.22 9.469.966 5.544 4.07l-.272-.273a.586.586 0 0 0-.992.316l-.412 2.41a.586.586 0 0 0 .677.676l2.41-.412a.586.586 0 0 0 .316-.992L6.974 5.5a8.003 8.003 0 0 1 11.443 2.006c1.777 2.634 1.777 6.189 0 8.823-2.918 4.325-8.843 4.74-12.338 1.245a7.953 7.953 0 0 1-2.182-4.066.985.985 0 0 0-1.061-.781 1.005 1.005 0 0 0-.896 1.195 9.983 9.983 0 0 0 3.708 5.932c3.587 2.779 8.753 2.737 12.298-.095 4.747-3.794 5.034-10.74.86-14.913z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="m14.938 14.706-1.167-1.51a3.01 3.01 0 0 1-.615-1.566l-.421-4.713a1 1 0 0 0-2 0l-.381 4.885a2.999 2.999 0 0 0 1.05 2.52l2.12 1.798a.999.999 0 1 0 1.414-1.414z"
                    />
                </g>
            </svg>
        ),
        link: '/',
        classname: '',
    },
];
export const roomsButtons = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#605F68"
                        d="M18.806 4.846C15.18 1.22 9.469.966 5.544 4.07l-.272-.273a.586.586 0 0 0-.992.316l-.412 2.41a.586.586 0 0 0 .677.676l2.41-.412a.586.586 0 0 0 .316-.992L6.974 5.5a8.003 8.003 0 0 1 11.443 2.006c1.777 2.634 1.777 6.189 0 8.823-2.918 4.325-8.843 4.74-12.338 1.245a7.953 7.953 0 0 1-2.182-4.066.985.985 0 0 0-1.061-.781 1.005 1.005 0 0 0-.896 1.195 9.983 9.983 0 0 0 3.708 5.932c3.587 2.779 8.753 2.737 12.298-.095 4.747-3.794 5.034-10.74.86-14.913z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="m14.938 14.706-1.167-1.51a3.01 3.01 0 0 1-.615-1.566l-.421-4.713a1 1 0 0 0-2 0l-.381 4.885a2.999 2.999 0 0 0 1.05 2.52l2.12 1.798a.999.999 0 1 0 1.414-1.414z"
                    />
                </g>
            </svg>
        ),
        link: '/',
        classname: '',
    },
];
